import { Directive, HostBinding } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';

@Directive({
    selector: '[luiSearchField]',
    standalone: false
})
export class SearchFieldDirective {
  @HostBinding('class') className = 'search-field';

  constructor(private matFormField: MatFormField) {
    matFormField.appearance = 'fill';
  }
}
